import React from 'react';
import { useForm } from 'react-hook-form';
import { replaceDefaultValues } from '../../helpers/form';
import FormElement from '../core/FormElement';
import StepFormSubStepButtons from '../StepForm/StepFormSubStepButtons';

interface Props {
  types: string[];
  onSubmit: (data: { [x: string]: any }) => void;
  onBackClick: () => void;
  salesType: 'construido' | 'sobre planos';
  defaultValues?: any;
}

export default function Form32(props: Props) {
  const { register, handleSubmit, errors } = useForm({
    defaultValues: replaceDefaultValues(
      {
        ownerName: '',
        ownerLastName: '',
        ownerDocumentType: '',
        ownerDocumentNumber: '',
      },
      props.defaultValues
    ),
  });

  return (
    <form onSubmit={handleSubmit(props.onSubmit)}>
      <h1>
        {props.salesType === 'construido'
          ? 'Información del propietario'
          : 'Información del vendedor'}
      </h1>

      <FormElement
        name="ownerName"
        label="Nombres*"
        placeholder="Nombres"
        inputRef={register({ required: true })}
        error={errors.ownerName}
        elementType="text"
      />
      <FormElement
        name="ownerLastName"
        label="Apellidos*"
        placeholder="Apellidos"
        inputRef={register({ required: true })}
        error={errors.ownerLastName}
        elementType="text"
      />
      <FormElement
        name="ownerDocumentType"
        label="Tipo de documento*"
        placeholder="Tipo de documento"
        inputRef={register({ required: true })}
        elementType="select"
        error={errors.ownerDocumentType}
        options={props.types.map((el) => ({ name: el, value: el }))}
      />
      <FormElement
        name="ownerDocumentNumber"
        label="Número del documento*"
        placeholder="Número del documento"
        error={errors.ownerDocumentNumber}
        inputRef={register({ valueAsNumber: true, required: true })}
        elementType="text"
      />

      <StepFormSubStepButtons onBackClick={props.onBackClick} />
    </form>
  );
}
